// extracted by css-extract-rspack-plugin
export default {"showBorder":"ListLoading-module__showBorder__VLjMa","ListLoadingHeader":"ListLoading-module__ListLoadingHeader__KnJPu"};